import {useEffect, useRef} from 'react'
import {gsap} from 'gsap'

export interface TileProps {
  className?: string
  colors: readonly [background: string, foreground: string]
  delay: number
}

type TileAnimationOptions = {
  delay: number
  selector: string
  scaleProperty: 'scale' | 'scaleX'
  skipFirst?: boolean
  transformOrigin: string
}

export function useTileAnimation({
  delay,
  selector,
  scaleProperty,
  skipFirst = true,
  transformOrigin,
}: TileAnimationOptions) {
  const svgRef = useRef<SVGSVGElement>(null)

  useEffect(() => {
    const svg = svgRef.current
    if (!svg || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    const context = gsap.context(() => {
      const elements = Array.from(svg.querySelectorAll(selector))
      const targets = skipFirst ? elements.slice(1) : elements
      const timeline = gsap.timeline({delay})
      const animation = {
        transformOrigin,
        duration: 0.7,
        stagger: 0.1,
        ease: 'expo.out',
      }

      if (scaleProperty === 'scaleX') {
        timeline.from(targets, {...animation, scaleX: 0})
      } else {
        timeline.from(targets, {...animation, scale: 0})
      }
    }, svg)

    return () => context.revert()
  }, [delay, scaleProperty, selector, skipFirst, transformOrigin])

  return svgRef
}
